"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const button_scss_1 = __importDefault(require("./styles/button.scss"));
/**
 * Material Icon Component
 */
function Icon({ className, name }) {
    return React.createElement("i", { className: classnames_1.default(className, 'material-icons') }, name);
}
exports.Icon = Icon;
function Button(props) {
    return (React.createElement(IconButton, Object.assign({ name: "" }, props), props.children));
}
exports.Button = Button;
function IconButton({ accent, children, className, disabled, lg, name, onClick, primary, tooltip, vertical }) {
    return (React.createElement("button", { className: classnames_1.default(className, children ? button_scss_1.default.label : button_scss_1.default.icon, disabled && button_scss_1.default.disabled, lg && button_scss_1.default.large, primary && button_scss_1.default.primary, accent && button_scss_1.default.accent, tooltip && button_scss_1.default.tooltipWrapper, vertical && button_scss_1.default.vertical), onClick: onClick },
        name ? React.createElement(Icon, { name: name }) : null,
        typeof children === 'object' ? children : React.createElement("span", null, children),
        tooltip ? React.createElement("div", { className: button_scss_1.default.tooltip }, tooltip) : null));
}
exports.IconButton = IconButton;
